/* eslint-disable max-len */
<template>
    <div class="detail-info-wrapper" :style="{backgroundColor: $root.officialBackgroundColor}">
        <official-header v-if="$root.officialJoinedStyle">
            <div class="basic-info trans-title">
                <div class="portrait">
                    <div :class="isMobile ? 'mobile-img-wrapper' : 'pc-img-wrapper'">
                        <img :src="info.icon">
                    </div>
                </div>
                <div class="name-tag">
                    <div
                        v-lazy-container="{selector: 'img'}" class="game-name vert-center"
                    >
                        <span>{{ info.appName }}</span>
                        <img class="trans-official-tag" data-src="https://b.bdstatic.com/searchbox/image/cmsuploader/20210422/1619069635970765.png">
                    </div>
                    <div class="game-other">
                        <div v-if="info.enName && !isMobile" class="game-tag trans-desc">
                            <span>{{ info.enName }}</span>
                        </div>
                        <div v-if="publisher" class="game-tag trans-desc">
                            厂商: {{ publisher }}
                        </div>
                    </div>
                    <div class="rank-wrapper">
                        <div class="rank-info">
                            <div
                                v-for="item of info.supportPlat"
                                :key="item"
                                class="classify"
                                :style="{
                                    backgroundColor: `${$root.officialHighLightFontColor}1A`,
                                    color: $root.officialHighLightFontColor,
                                    borderColor: `${$root.officialHighLightFontColor}80`,
                                }"
                            >
                                {{ item }}
                            </div>
                            <div
                                v-for="(item, index) of info.tags"
                                :key="index"
                                :style="{
                                    backgroundColor: 'rgba(255, 255, 255, .1)',
                                    color: '#FFF',
                                    borderColor: 'rgba(255, 255, 255, .5)',
                                }"
                                class="classify"
                            >
                                {{ item }}
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    v-if="isShowScore && info.score" class="info-score"
                    @click="scrollTopComment"
                >
                    <div class="score-content">{{ info.score }}</div>
                    <!-- eslint-disable -->
                    <div class="star-content-wrap">
                        <div class="star-content">
                            <CStar 
                                v-model="info.score / 2"
                            />
                        </div>
                    </div>
                    <!-- eslint-enable -->
                </div>
            </div>
            <div
                v-if="showNopkgTips && $root.officialJoinedStyle"
                class="no-pak-tips"
                :style="{marginTop: `${20 / 12.42}vw`, marginLeft: `${220 / 12.42}vw`}"
            >当前游戏暂无下载资源</div>
            <div
                v-if="$root.officialJoinedStyle && info.game_simple_desc && !isShowProductDetail"
                class="troduction official-style"
            >
                <img :src="info.officialJoined ? quotes_left[0] : quotes_left[1]" class="quotes-left">
                <div
                    class="troduction_text"
                    :style="{color: info.officialJoined
                        ? '#fff' : '#3388FF',
                    }"
                >
                    {{ info.game_simple_desc }}
                </div>
                <img :src="info.officialJoined ? quotes_right[0] : quotes_right[1]" class="quotes-right">
            </div>
            <download-btn
                v-if="!$root.isFromTiebaFeed"
                :app-detail="appDetail"
                :is-mobile="isMobile"
                :tieba-info="tiebaInfo"
                class="top-btn-official"
            />
            <div
                v-if="showRecommendDownload && appDetail.recommend_download"
                class="recommend-tip"
            >
                <recmmend-selection
                    :app-detail="appDetail"
                />
            </div>
        </official-header>
        <div
            class="detail-info-content" :class="isShowProductDetail && $root.officialJoinedStyle ? 'top-distance' : ''"
        >
            <!-- 商品详情 -->
            <product-info
                v-if="isShowProductDetail"
                :pro-info="proInfo"
                :info="info"
            />
            <div class="detail-content">
                <!-- 官方入驻 且 横图 -->
                <div
                    v-if="media && media.length > 0 && $root.officialJoinedStyle"
                    ref="officialVideo"
                    class="media-list scroll-x"
                >
                    <div
                        v-for="(item, index) of media" :key="index"
                        :class="['media-list-item', (item.type === 1
                            && !videoVertical) ? 'media-list-item-h' : isVertical ? '' : 'media-list-item-h']"
                    >
                        <game-video
                            v-if="item.type === 1"
                            :poster="item.poster"
                            :src="item.url"
                            :index="index"
                            :is-v="isVertical"
                            :is-official="isOfficial"
                            :auto-play="index === 0"
                            :class="{'video-h': !isOfficial && !videoVertical}"
                        />
                        <img
                            v-else-if="!isVertical"
                            v-lazy="item.poster"
                            preview="99"
                            @load="refreshPreview"
                        >
                    </div>
                </div>

                <div v-if="isShowPrivacyLine && $root.officialJoinedStyle" class="privacy-line">
                    <privacy-line
                        :privacy-info="privacyInfo"
                        :publisher="publisher"
                    />
                </div>
                <div v-if="!$root.officialJoinedStyle" class="basic-info">
                    <div class="portrait">
                        <div :class="isMobile ? 'mobile-img-wrapper' : 'pc-img-wrapper'">
                            <img :src="info.icon">
                        </div>
                    </div>
                    <div class="name-tag">
                        <div class="game-name">
                            <span>{{ info.appName }}</span>
                            <img v-if="info.officialJoined" :src="official">
                        </div>
                        <div v-if="!isMobile" class="game-other game-tag">
                            <span>{{ info.enName }}</span>
                        </div>
                        <div class="rank-info">
                            <div
                                v-for="item of info.supportPlat"
                                :key="item" class="classify"
                                :style="{
                                    backgroundColor: $root.officialJoinedStyle ?
                                        `${$root.officialHighLightFontColor}1A` : 'rgba(51,136,255,0.08)',
                                    color: $root.officialJoinedStyle ? $root.officialHighLightFontColor : '#3388FF',
                                    borderColor: $root.officialJoinedStyle ?
                                        `${$root.officialHighLightFontColor}80` : '#3388FF80',
                                }"
                            >
                                {{ item }}
                            </div>
                            <div
                                v-for="(item, index) of info.tags" :key="index"
                                :style="{
                                    backgroundColor: $root.officialJoinedStyle ?
                                        'rgba(255, 255, 255, .1)' : 'rgba(133,133,133,0.06)',
                                    color: $root.officialJoinedStyle ? '#FFF' : '#858585',
                                    borderColor: $root.officialJoinedStyle ? 'rgba(255, 255, 255, .5)' : '#85858580',
                                }"
                                class="classify"
                            >
                                {{ item }}
                            </div>
                        </div>
                        <div v-if="showNopkgTips && !$root.officialJoinedStyle" class="no-pak-tips">当前游戏暂无下载资源</div>
                    </div>
                    <div
                        v-if="isShowScore && info.score" class="info-score"
                        @click="scrollTopComment"
                    >
                        <div class="score-content">{{ info.score }}</div>
                        <!-- eslint-disable -->
                    <div class="star-content-wrap">
                        <div class="star-content">
                            <CStar 
                                v-model="info.score / 2"
                            />
                        </div>
                    </div>
                    <!-- eslint-enable -->
                    </div>
                </div>
                <div v-if="isShowPrivacyLine && !$root.officialJoinedStyle" class="privacy-line">
                    <privacy-line
                        :privacy-info="privacyInfo"
                        :publisher="publisher"
                    />
                </div>
                <div v-if="appDetail.appType === 11">
                    <rank-anchor
                        v-if="isIOS"
                        :info="info"
                        :rank-list="rankList"
                        @toRank="jumpToRankList"
                    />
                    <tieba-rank-entry
                        v-if="!isIOS && tiebaRankEntryInfo"
                        :game-info="info"
                        :rank-entry-info="tiebaRankEntryInfo"
                    />
                </div>
                <download-btn
                    v-if="!$root.officialJoinedStyle && !$root.isFromTiebaFeed"
                    :app-detail="appDetail"
                    :is-mobile="isMobile"
                    :tieba-info="tiebaInfo"
                    class="c-gap-top-60 top-btn-normal"
                />
                <div v-if="appDetail.third_app_store_name" class="third-app-store">
                    <img :src="downloadShopIcon" class="download-shop-icon">
                    <div class="third-app-store-info">
                        由第三方应用商店提供安装服务（来自{{ appDetail.third_app_store_name }}）
                    </div>
                </div>
                <div v-if="!$root.officialJoinedStyle && info.game_simple_desc" class="troduction">
                    <img :src="quotes_left[1]" class="quotes-left">
                    <div
                        class="troduction_text"
                        :style="{color: '#3388FF'}"
                    >
                        {{ info.game_simple_desc }}
                    </div>
                    <img :src="quotes_right[1]" class="quotes-right">
                </div>
                <section
                    v-if="isShowDownloadArea &&
                        isMobile &&
                        digital_info_arr &&
                        digital_info_arr.length > 1"
                    class="c-gap-top"
                >
                    <div
                        ref="downloadArea"
                        class="downloadArea"
                    >
                        <template
                            v-for="item in digital_info_arr.slice(0, 2)"
                        >
                            <div
                                :key="item.key"
                                class="data-item"
                            >
                                <div class="data-item-value">{{ item.value }}</div>
                                <div class="data-item-label">{{ item.label }}</div>
                            </div>
                            <div
                                v-if="item.isNeedSpilt"
                                :key="item.key"
                                class="split-line"
                            >
                            </div>
                        </template>
                    </div>
                </section>
                <section v-if="!isMobile && platIcon && platIcon.length > 0" class="c-gap-top">
                    <div
                        v-if="platIcon && platIcon.length === 1 && platDetail[0].length === 1"
                        class="single-end-tour"
                    >
                        <div class="left"><img :src="platIcon[0].icon">{{ platIcon[0].name }}</div>
                        <div class="right">{{ platDetail[0][0].key }}{{ platDetail[0][0].value }}</div>
                    </div>
                    <div v-else class="end-tour">
                        <div class="end-tour-tab">
                            <div
                                v-for="(item, index) of platIcon" :key="index"
                                :class="['tab-item', tourIndex === index ? 'tab-tiem-focus' : '']"
                            >
                                <div
                                    class="tab-name"
                                    @click="changeTourIndex(index)"
                                >
                                    <img :src="tourIndex === index ? item.icon : item.iconGray">{{ item.name }}
                                </div>
                            </div>
                        </div>
                        <div class="end-tour-content scroll-x">
                            <template v-for="(item, index) of platDetail[tourIndex]">
                                <div
                                    :key="index" class="content-item"
                                    :class="{'width-fixed': platDetail[tourIndex].length > 3}"
                                >
                                    <div class="content-item-key">{{ item.key }}</div>
                                    <div class="content-item-value">{{ item.value }}</div>
                                </div>
                                <div
                                    v-if="index !== platDetail[tourIndex].length - 1" :key="'sp-' + index"
                                    class="split-line"
                                ></div>
                            </template>
                        </div>
                    </div>
                </section>
                <section
                    v-if="!isOfficial && baikeBlockList && baikeBlockList.length && media && media.length"
                    id="officialVideo"
                    class="c-gap-top"
                >
                    <div class="desc">
                        <head-title
                            v-if="!$root.officialJoinedStyle"
                            text="预览图"
                            :has-arrow="false"
                            class="previewImg"
                        />
                        <!-- 非官方竖图 + 简介 -->
                        <div
                            v-if="media && media.length > 0 && isVertical"
                            ref="officialVideo"
                            class="media-list scroll-x"
                        >
                            <div
                                v-for="(item, index) of media" :key="index"
                                :class="['media-list-item', isVertical ? 'media-list-item-v' : 'media-list-item-h']"
                            >
                                <game-video
                                    v-if="item.type === 1 && videoVertical"
                                    :poster="item.poster"
                                    :src="item.url"
                                    :index="index"
                                    :is-v="isVertical"
                                    :is-official="isOfficial"
                                    :class="{'video-h': !isOfficial && !videoVertical && isVertical}"
                                />
                                <img
                                    v-else
                                    v-lazy="item.poster"
                                    preview="99"
                                    @load="refreshPreview"
                                >
                            </div>
                        </div>
                    </div>
                </section>
                <section class="c-gap-top">
                    <div v-if="appType === 12" class="pricetrend">
                        <div
                            v-if="skuVerList.length !== 0" class="pricetrend-top"
                            @click.stop="showPricetrend"
                        >
                            <head-title
                                text="价格趋势"
                                :has-arrow="false"
                            />
                            <div
                                v-if="!showPriceTrend"
                                class="pricetrend-top-right"
                            >
                                <span class="pricetrend-showMore">展开</span>
                                <img
                                    :src="iconShowMore" alt=""
                                    class="pricetrend-icon"
                                >
                            </div>
                            <div v-if="!!showPriceTrend" class="pricetrend-top-right">
                                <span
                                    :class="isLately === 1 ? 'left' : 'right'"
                                    @click.stop="showLately"
                                >
                                    {{ priceTrendData.time_tag_list[0].time_tag_name }}
                                </span>
                                <span class="middle">|</span>
                                <span
                                    :class="isLately === 0 ? 'left' : 'right'"
                                    @click.stop="showHistory"
                                >
                                    {{ priceTrendData.time_tag_list[1].time_tag_name }}
                                </span>
                            </div>
                        </div>
                        <pricetrend
                            :show-price-trend="showPriceTrend"
                            :is-lately="isLately"
                            :is-all="isAll"
                            @givepriceTrendData="givepriceTrendData"
                        />
                    </div>
                </section>
                <section v-if="baikeBlockList && baikeBlockList.length" class="c-gap-top">
                    <div class="desc">
                        <head-title
                            text="游戏百科"
                            :has-arrow="false"
                        />
                        <baike-module
                            :block-list="baikeBlockList"
                            :is-show-more="isShowBkMore"
                            :is-loading="isLoadingBaikeData"
                            :plat-base-info="info.platBaseInfo"
                            :contact-info="contactInfo"
                            @showMore="showBKMore"
                            @foldBaike="foldBaiKe"
                            @baikeWrapperChange="baikeWrapperChange"
                            @baikeBlockChange="baikeBlockChange"
                        />
                    </div>
                </section>
                <!-- 新官方动态 -->
                <section
                    v-if="officialTimeAxis && officialTimeAxis.list
                        && officialTimeAxis.list.items && officialTimeAxis.list.items.length > 0"
                    ref="officialNews"
                    class=" offical-gap-top"
                >
                    <time-axis-official
                        :official-joined="officialJoined"
                        :official-time-axis="officialTimeAxis"
                        :game-icon="info.icon"
                        :app-name="info.appName"
                        :follow-num-show="info.follow_num_show"
                    />
                </section>
                <section
                    v-if="info.desc && (!baikeBlockList || !baikeBlockList.length)" ref="briefArea"
                    class="c-gap-top" @click.stop="jumpDesc"
                >
                    <div class="desc">
                        <head-title
                            text="简介"
                            :has-arrow="true"
                        />
                        <div class="desc-info">
                            <div class="clamp-content clamp-content-5">{{ info.desc }}</div>
                            <!-- <div>
                            <img :src="arrow[0]" class="arrow-right">
                        </div> -->
                        </div>
                    </div>
                </section>
                <section v-if="developerWord && developerWord.content" class="c-gap-top">
                    <devloper-word
                        :developer-word="developerWord"
                    />
                </section>
                <div
                    v-if="discussZone && discussZone.list && discussZone.list.length > 0
                        && discussZone.list[0].publisher !== ''"
                >
                    <discuss-zone
                        :discuss-zone="discussZone"
                    />
                </div>
                <div
                    v-if="(isOfficial || !baikeBlockList || !baikeBlockList.length) && media
                        && media.length > 0 && isVertical"
                    ref="officialVideo"
                    class="media-list scroll-x"
                >
                    <div
                        v-for="(item, index) of media" :key="index"
                        :class="['media-list-item', isVertical ? 'media-list-item-v' : 'media-list-item-h']"
                    >
                        <game-video
                            v-if="item.type === 1 && videoVertical"
                            :poster="item.poster"
                            :src="item.url"
                            :index="index"
                            :is-v="isVertical"
                            :is-official="isOfficial"
                            :class="{'video-h': !isOfficial && !videoVertical && isVertical}"
                        />
                        <img
                            v-else-if="item.type !== 1"
                            v-lazy="item.poster"
                            preview="99"
                            @load="refreshPreview"
                        >
                    </div>
                </div>
                <section
                    v-if="!isMobile && info.platBaseInfo && Object.keys(info.platBaseInfo).length > 0 && showPConfig"
                    class="configuration-request c-gap-top"
                >
                    <head-title
                        text="PC配置要求"
                        :url="confUrl"
                        value="configure"
                    />
                </section>
                <app-detail-b-k-catalog
                    v-show="baikeBlockShow && baikeTitleList.length > 2"
                    :title-list="baikeTitleList"
                    :is-show-cata="isShowBKCata"
                    :is-show-cata-clock="isShowBKCataClock"
                    :current-index="catalogCurIndex"
                    :is-show-content-all="isShowBaikeAll"
                    @hideCatalog="hideCatalog"
                    @showCatalog="showCatalog"
                    @changeBlock="changeBlock"
                    @shieldScrollEvent="shieldScrollEvent"
                    @foldBaiKe="foldBaiKe"
                />
            </div>
        </div>
    </div>
</template>

<script>
import OfficialHeader from './app-detail-official-header';
import HeadTitle from './app-detail-head';
import GameVideo from '../video/app-video-box';
import DiscussZone from './app-detail-discusszone';
import BaikeModule from './app-detail-bk-module';
import DevloperWord from './app-detail-developer-word';
import PrivacyLine from './app-detail-privacy-line';
import AppDetailBKCatalog from './app-detail-bk-catalog';
import Pricetrend from './app-detail-pricetrend.vue';
import TimeAxisOfficial from './app-detail-time-axis-official-module';
import ProductInfo from './app-detail-product-info.vue';
import RankAnchor from './app-detail-rank-anchor.vue';
import DownloadBtn from './app-detail-download-top.vue';
import RecmmendSelection from './app-detail-recommend-selection.vue';
import TiebaRankEntry from './app-detail-tieba-rank-entry.vue';
import {getDeepValue} from '@/utils/utility.js';

import right from 'public/assets/imgs/ic_more_grey.png';
import ic_right from 'public/assets/imgs/ic_right.png';
import ic_down from 'public/assets/imgs/ic_down_grey.png';
import wheat_left from 'public/assets/imgs/wheat_left.png';
import wheat_right from 'public/assets/imgs/wheat_right.png';
import official from 'public/assets/imgs/official.png';
import ic_safe from 'public/assets/imgs/ic_safe.png';
import ic_arrow_up from 'public/assets/imgs/ic_arrow_up.png';
import ic_arrow_down from 'public/assets/imgs/ic_arrow_down.png';
import CStar from './c-star';
import {getQueryString, getUrlParams} from '@/utils/url';
import {isIOS} from '@/utils/browser';
import {throttle} from 'throttle-debounce';
import api from '@/api';
import {on} from '@/utils/dom';
import quotes_left_blue from 'public/assets/imgs/quotes_left_blue.png';
import quotes_right_blue from 'public/assets/imgs/quotes_right_blue.png';
import quotes_left_white from 'public/assets/imgs/quotes_left_white.png';
import quotes_right_white from 'public/assets/imgs/quotes_right_white.png';
import downloadShopIcon from 'public/assets/imgs/download-shop-icon.png';
export default {
    components: {
        OfficialHeader,
        CStar,
        HeadTitle,
        Pricetrend,
        GameVideo,
        DiscussZone,
        BaikeModule,
        AppDetailBKCatalog,
        DevloperWord,
        PrivacyLine,
        TimeAxisOfficial,
        ProductInfo,
        RankAnchor,
        DownloadBtn,
        RecmmendSelection,
        TiebaRankEntry,
    },
    props: {
        info: {
            type: Object,
            required: true,
        },
        appDetail: {
            type: Object,
            required: true,
        },
        media: {
            type: Array,
            required: true,
        },
        isMobile: {
            type: Boolean,
            required: true,
        },
        isVertical: {
            type: Boolean,
            required: false,
        },
        isOfficial: {
            type: Boolean,
            required: false,
        },
        buyUrlInfo: {
            type: Object,
            default: () => ({}),
        },
        isCooperation: {
            type: String,
            default: '',
        },
        commentCnt: {
            type: Number,
            default: 0,
        },
        downloadNum: {
            type: String,
            default: '',
        },
        baiduIndex: {
            type: String,
            default: '',
        },
        rank: {
            type: Number,
            default: 0,
        },
        discussZone: {
            type: Object,
            default: () => ({}),
        },
        container: {
            type: Number,
            default: 0,
        },
        videoVertical: {
            type: Boolean,
            required: false,
        },
        baikeTitles: {
            type: Array,
            default: () => ([]),
        },
        baikeBlocks: {
            type: Array,
            default: () => ([]),
        },
        isShowWikiGuide: {
            type: Boolean,
            required: false,
        },
        isScrollChange: {
            type: Boolean,
            required: false,
        },
        contactInfo: {
            type: Object,
            default: () => ({}),
        },
        developerWord: {
            type: Object,
            default: () => ({}),
        },
        userStatus: {
            type: Object,
            default: () => ({}),
        },
        privacyInfo: {
            type: Object,
            default: () => ({}),
        },
        officialJoined: {
            type: Boolean,
            required: false,
        },
        officialTimeAxis: {
            type: Object,
            default: () => ({}),
        },
        packageList: {
            type: Array,
            default: () => ([]),
        },
        isShowProductDetail: {
            type: Boolean,
            required: false,
        },
        isShowScore: {
            type: Boolean,
            required: false,
        },
        isShop: {
            type: Boolean,
            required: false,
        },
        appType: {
            type: Number,
            default: 0,
        },
        rankList: {
            type: Array,
            default: () => [],
        },
        tiebaInfo: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            arrow: [right, ic_right],
            tourIndex: 0,
            plat: [],
            platDetail: [],
            platIcon: [],
            configPlat: [],
            showPConfig: false,
            confUrl: '',
            wheat: [wheat_left, wheat_right],
            official: official,
            safeCheck: ic_safe,
            iconShow: ic_arrow_up,
            iconShowMore: ic_down,
            openCheckInfos: false,
            baikeBlockList: [],
            baikeTitleList: [],
            isLoadingBaikeData: false,
            isShowBkMore: true,
            isShowBKCata: false, // 是否展示百科目录
            isShowBKCataClock: false, // 展示百科目录3秒倒计时后隐藏
            isShowBaikeAll: false, // 是否展示右侧悬浮折叠按钮
            catalogCurIndex: 0,
            baikeBlockShow: false,
            shieldScrollCloseCata: false, // 屏蔽滚动时关闭百科目录行为
            isShowDownloadArea: false, // 用于控制是否展示下载区域
            quotes_left: [quotes_left_white, quotes_left_blue],
            quotes_right: [quotes_right_white, quotes_right_blue],
            firstRender: true,
            // 商品信息
            proInfo: {},
            showPriceTrend: false,
            isLately: 1,
            priceTrendInfo: [],
            priceTrendData: {},
            isAll: 'latest30d',
            skuVerList: [],
            priceTrendText: '',
            tiebaRankEntryInfo: null, // 贴吧榜单入口信息
            downloadShopIcon: downloadShopIcon,
        };
    },
    computed: {
        digital_info_arr() {
            if (!this.info || !this.info.digital_info) {
                return [];
            }
            return this.info.digital_info.map((e, i) => {
                let [[key, value]] = Object.entries(e);
                return {
                    label: key,
                    value,
                    isNeedSpilt: i + 1 !== 2,
                };
            });
        },
        isShowPrivacyLine() {
            // const isPackage = this.packageList.length && this.packageList[0] && this.packageList[0].action === 1;
            const isIos = isIOS();
            return this.isMobile && !isIos && this.privacyInfo && this.privacyInfo.privacy;
        },
        publisher() {
            const dev = getDeepValue(this.info, 'platBaseInfo.Android.dev');
            const publisher = getDeepValue(this.info, 'publisher');
            return dev || publisher || '';
        },
        showRecommendDownload() {
            const thePackage = this.appDetail.package_list && this.appDetail.package_list[0] || {};
            const {action} = thePackage;
            const {DOWNLOAD} = this.$root.DOWNLOAD_ACTIONS;
            return action === DOWNLOAD
                && ((this.isMobile && this.appDetail.package_list && this.appDetail.package_list.length)
                    || (this.appDetail.bussinessInfo && this.appDetail.bussinessInfo.appRcv));
        },
        isIOS() {
            return isIOS();
        },
        showNopkgTips() {
            if (this.appType === 11) {
                if (this.appDetail.package_list?.length || this.appDetail.bussinessInfo?.appRcv) {
                    return false;
                }
                return true;
            }
            return false;
        },
    },
    watch: {
        isScrollChange() {
            const timer = setTimeout(() => {
                clearTimeout(timer);
                this.baikeBlockShow = true;
                this.$emit('baikeContentShow');
                this.isShowBKCataClock = true;
            }, 300);
        },
    },
    created() {
        if (this.info.platBaseInfo) {
            const info = this.info.platBaseInfo;
            this.plat = Object.keys(info);
            this.platDetail = this.plat.map(item => {
                return info[item].tabList;
            });
            this.platIcon = Object.values(info).map(item => {
                return item.platIcon;
            });
            this.confUrl = 'http://' + window.location.host + '/static/game/spec.html?appId=' + getQueryString('appId') + '&plat=' + this.plat[0];
        }
        if (this.info.rank && this.info.rank.name) {
            this.doDisplayLog('listArea', {
                areaName: this.info.rank.name + 'NO.' + this.info.rank.index,
            });
        }
        if (!this.isMobile && (this.plat.indexOf('steam') >= 0 || this.plat.indexOf('wegame') >= 0)) {
            this.doDisplayLog('module', {moduleName: 'PC配置要求'});
        }
        if (this.info.desc) {
            this.doDisplayLog('module', {moduleName: '简介'});
        }
        if (this.baikeBlocks && this.baikeBlocks.length) {
            this.baikeBlockList = [...this.baikeBlocks];
            this.baikeTitleList = ['游戏百科', ...(this.baikeTitles || [])];
            this.doDisplayLog('module', {moduleName: '游戏百科'});
        }
        // 商品信息
        if (this.info.goods_info) {
            const srcId = getQueryString('srcid');
            this.proInfo = this.info.goods_info;
            // 商品信息展示打点
            this.doDisplayLog('module', {srcId: srcId, skuId: this.proInfo.sku_id, moduleName: '购买信息'});
        }
        this.showPConfigFun();
        on(window, 'scroll', throttle(200, this.handleScroll.bind(this)));
        this.isShowDownloadArea = getQueryString('from') === 'sem';
        this.getTiebaRankEntryData();
        // 是否是应用商店下载
        if (this.appDetail.third_app_store_name) {
            this.doDisplayLog('ShopDisplay', {gameName: this.appDetail.appName, gameId: this.appDetail.appId});
        }
    },
    mounted() {
        const timer = setTimeout(() => {
            const container = this.$parent.$refs.detailContainer.getBoundingClientRect().top;
            const officialVideo = this.$refs.officialVideo
                && this.$refs.officialVideo.getBoundingClientRect().top - container - 30 || 0;
            const officialNews = this.$refs.officialNews
                && this.$refs.officialNews.getBoundingClientRect().top - container - 5 || 0;
            const downloadArea = this.$refs.downloadArea
                && this.$refs.downloadArea.getBoundingClientRect().top - container - 5 || 0;
            const briefArea = this.$refs.briefArea
                && this.$refs.briefArea.getBoundingClientRect().top - container - 5 || 0;
            const topObj = {
                'officialVideo': officialVideo,
                'officialNews': officialNews,
                'downloadInfo': downloadArea,
                'briefArea': briefArea,
            };
            let anchorPoint = this.getAnchorPointFromUrl(window.location.href);
            if (anchorPoint && anchorPoint.startsWith('_wiki-')) { // 百科特殊的锚点逻辑
                // eslint-disable-next-line radix
                const current = parseInt(anchorPoint.split('-')[1]) + 1 || 0;
                this.changeBlock(current);
                return;
            }
            const top = topObj[anchorPoint];
            if (top) {
                window.scrollTo({
                    top,
                });
            }
            clearTimeout(timer);
        }, 500);
        this.closePricetrend();
    },
    methods: {
        // 获取贴吧榜单入口卡片数据
        getTiebaRankEntryData() {
            api.zone.getTiebaRankEntryData({
                game_id: getQueryString('appId'),
            }).then(res => {
                this.tiebaRankEntryInfo = res;
            });
        },
        changeTourIndex(index) {
            this.tourIndex = index;
            this.confUrl = 'http://' + window.location.host + '/static/game/spec.html?appId=' + getQueryString('appId') + '&plat=' + this.plat[index];
            this.doClickLog(this.platIcon[index].logName, {});
        },
        jumpDesc() {
            let plat = '';
            if (this.isMobile) {
                plat = 'android';
                if (isIOS()) {
                    plat = 'ios';
                }
            }
            else {
                plat = this.plat[this.tourIndex];
            }
            const {gameName, gameType} = this.$root.extData || {};
            window.location.href = 'http://' + window.location.host + '/static/game/desc.html?appId=' + getQueryString('appId') + '&plat=' + plat + '&gameName=' + gameName + '&gameType=' + gameType;
        },
        jumpRankPage(url) {
            window.location.href = url;
            this.doClickLog('listArea', {
                areaName: this.info.rank.name + 'NO.' + this.info.rank.index,
            });
        },
        refreshPreview() {
            this.$previewRefresh();
        },
        scrollTopComment() {
            let container = this.$parent.$refs.detailContainer.getBoundingClientRect().top;
            let comment = this.$parent.$refs.comment && this.$parent.$refs.comment.getBoundingClientRect().top;
            if (!comment) {
                return;
            }
            window.scrollTo({
                top: comment - container - 10,
            });
        },
        getAnchorPointFromUrl(url = '') {
            if (!url) {
                return {};
            }
            const arr = /\?(.*)/.exec(url);
            if (!arr || arr.length < 1) {
                return {};
            }
            let anchorPoint = '';
            const queryStr = arr[1];
            queryStr.split('#').forEach(query => {
                anchorPoint = query;
            });
            return anchorPoint;
        },
        doDisplayLog(value, obj) {
            this.$logger.display({
                value: value,
                ext: {
                    item: [
                        {
                            id: '',
                            ext: Object.assign(obj, this.$root.extData),
                            pos: '',
                        },
                    ],
                },
            });
        },
        doClickLog(value, obj, pos = '') {
            let content = {
                value: value,
                ext: {
                    id: '',
                    ext: Object.assign(obj, this.$root.extData),
                    pos: pos,
                },
            };
            this.$logger.click(content);
        },
        openCheckInfo() {
            this.openCheckInfos = !this.openCheckInfos;
            if (this.openCheckInfos) {
                this.iconShow = ic_arrow_down;
            }
            else {
                this.iconShow = ic_arrow_up;
            }
        },
        closeCheckInfos() {
            this.openCheckInfos = false;
            this.iconShow = ic_arrow_up;
        },
        showPConfigFun() {
            if (this.info.platBaseInfo) {
                const platBaseInfo = this.info.platBaseInfo || {};
                const keys = platBaseInfo && Object.keys(platBaseInfo);
                if (keys.includes('Steam')) {
                    this.configPlat = 'Steam';
                }
                else if (keys.includes('WeGame')) {
                    this.configPlat = 'WeGame';
                }
                else if (keys.includes('PC')) {
                    this.configPlat = 'PC';
                }
                else {
                    return false;
                }
                const config = platBaseInfo[this.configPlat].osConf || {};
                this.showPConfig = config && !(config instanceof Array) && Object.keys(config).length;
                return this.showPConfig;
            }
        },
        // 拉取百科全部数据
        async fetchBaiKeInfo() {
            if (this.alreadyFetchBaiKeInfo) {
                this.isShowBkMore = false;
                this.isShowBaikeAll = true;
                return;
            }
            let params = {
                data: {
                    app_id: getQueryString('appId'),
                },
            };
            this.isLoadingBaikeData = true;
            const {title_list: titleList, block_list: blockList} = await api.zonenews.getAppWiki(params);
            this.baikeBlockList = blockList;
            this.baikeTitleList = ['游戏百科', ...(titleList || [])];
            this.isLoadingBaikeData = false;
            this.isShowBkMore = false;
            this.isShowBaikeAll = true;
            this.alreadyFetchBaiKeInfo = true;
        },
        showBKMore() {
            this.fetchBaiKeInfo();
            let content = {
                value: 'expandMore',
                ext: {
                    id: '',
                    ext: Object.assign({moduleName: '游戏百科'}, this.$root.extData),
                    pos: '',
                },
            };
            this.$logger.click(content);
        },
        // 滚动百科内容，百科内容整体展现和隐藏
        async baikeWrapperChange(param) {
            this.baikeBlockShow = param.isIntersecting;
        },
        // 滚动百科内容，百科目录联动
        baikeBlockChange(param) {
            if (!this.shieldScrollCloseCata) {
                const index = Number(param.id.slice(-1));
                const title = this.baikeTitleList[1];
                if (title !== '') {
                    this.catalogCurIndex = index + 1;
                }
                else {
                    if (index !== 0) {
                        this.catalogCurIndex = index + 1;
                    }
                    else {
                        this.catalogCurIndex = index;
                    }
                }
            }
        },
        // 隐藏百科悬浮目录
        hideCatalog() {
            this.isShowBKCata = false;
            this.doClickLog('retract', {moduleName: '目录'});
        },
        // 展示百科悬浮目录
        showCatalog() {
            this.isShowBKCata = true;
            this.doClickLog('catalog', {});
            if (!this.alreadyShowCatalog) {
                this.doDisplayLog('module', {moduleName: '目录'});
                this.alreadyShowCatalog = true;
            }
        },
        // 点击目录某一块标题锚点百科内容
        async changeBlock(index) {
            if (this.isShowBkMore) {
                await this.fetchBaiKeInfo();
                await this.$nextTick();
            }
            this.isShowBKCataClock = !this.isShowBKCataClock;
            this.catalogCurIndex = index;
            let blockEle = null;
            if (index === 0) { // 锚点到游戏百科
                blockEle = document.getElementsByClassName('baike-wrapper')[0];
            }
            else {
                blockEle = document.getElementById('baike-block-' + (index - 1));
            }
            if (blockEle) {
                const scrollY = blockEle.offsetTop + blockEle.offsetParent.offsetTop - document.body.scrollTop
                    - Math.floor(340 * (window.innerWidth / 1242));
                window.scrollTo(0, scrollY);
                this.doClickLog('title', {
                    moduleName: '目录',
                    titleName: this.baikeTitleList[index],
                }, index);
            }
        },
        // 页面滚动时关闭百科目录，如果当前处于屏蔽滚动行为时，则滚动不关闭目录
        handleScroll() {
            if (this.isShowWikiGuide && this.baikeBlockShow) {
                this.$emit('baikeContentShow');
                this.isShowBKCataClock = true;
            }
            if (!this.shieldScrollCloseCata) {
                this.isShowBKCata = false;
            }
            if (!this.foldBKbtnShow && !this.isShowBkMore) {
                const foldBaikeBtn = document.getElementById('foldBaikeBtn');
                if (foldBaikeBtn) {
                    const foldBaikeBtnTop = foldBaikeBtn.getBoundingClientRect().top;
                    if (foldBaikeBtnTop < window.innerHeight) {
                        this.doDisplayLog('retract', {moduleName: '游戏百科'});
                        this.foldBKbtnShow = true;
                    }
                }
            }
        },
        // 屏蔽滚动时关闭百科目录行为
        shieldScrollEvent(isShield) {
            this.shieldScrollCloseCata = isShield;
        },
        foldBaiKe(clickPos) {
            this.isShowBkMore = true;
            this.isShowBaikeAll = false;
            this.$nextTick(() => {
                const baikeWrapper = document.getElementsByClassName('baike-wrapper')[0];
                if (baikeWrapper) {
                    window.scrollTo({
                        top: baikeWrapper.offsetTop + (baikeWrapper.offsetHeight * 0.6),
                    });
                }
            });
            let content = {
                value: 'retract',
                ext: {
                    id: '',
                    ext: Object.assign({moduleName: '游戏百科', clickPos}, this.$root.extData),
                    pos: '',
                },
            };
            this.$logger.click(content);
        },
        // 展示商品信息模块
        // showProInfo() {
        //     this.doDisplayLog('module', {moduleName: '购买信息'});
        // }
        showPricetrend() {
            this.showPriceTrend = true;
        },
        showLately() {
            this.isLately = 1;
            this.isAll = 'latest30d';
        },
        showHistory() {
            this.isLately = 0;
            this.isAll = 'all';
        },
        givepriceTrendData(priceTrendData, skuVerList, priceTrendText) {
            this.priceTrendData = priceTrendData;
            this.skuVerList = skuVerList;
            this.priceTrendText = priceTrendText;
            this.$emit('givepriceTrendData', this.priceTrendData, this.priceTrendText);
        },
        closePricetrend() {
            document.addEventListener('click', e => {
                this.showPriceTrend = false;
            });
        },
        jumpToRankList(index) {
            this.$emit('toRankList', index);
        },
    },
};

</script>

<style lang="scss">
    @import "~@/common/style/mixin/utils";
    $design-width: 1242;

    .detail-info-wrapper {
        color: #1F1F1F;
        .top-distance {
            margin-top: px2rem(45);
        }
        .recommend-tip {
            margin: px2rem(-80) 0 px2rem(80);
        }
        .detail-info-content {
            border-radius: px2rem(36) px2rem(36) 0 0;
            background-color: #FFF;
            .detail-content {
                padding: px2rem(54) px2rem(51) 0 px2rem(51);
            }
            .privacy-line {
                margin: px2rem(51) 0 0;
            }
        }
        .top-btn-official {
            margin: px2rem(-20) auto px2rem(80);
        }
        .top-btn-normal {
            margin-bottom: px2rem(-20);
        }
        .third-app-store {
            display: flex;
            align-items: center;
            margin-top: 36px;
            .download-shop-icon {
                width: 42px;
                height: 42px;
                margin-right: 12px;
            }
            .third-app-store-info {
                opacity: 0.5;
                font-family: PingFangSC-Regular;
                font-size: 42px;
                color: #1F1F1F;
                line-height: 42px;
                font-weight: 400;
            }
        }
        .troduction {
            display: flex;
            justify-content: center;
            align-items: center;
            font-weight: 500;
            padding-top: px2rem(70);
            &.official-style {
                padding:px2rem(70) px2rem(0) px2rem(70) px2rem(0);
            }
            .troduction_text {
                font-size: px2rem(57);
                padding:0 px2rem(45);
                text-align: center;
                -webkit-line-clamp: 2;
                overflow: hidden;
                display: -webkit-box;
                -webkit-box-orient: vertical;
            }
            img {
                width: px2rem(53);
                height: px2rem(44);
            }
        }
        .downloadArea {
            background-color: #F8F8F8;
            border-radius: px2rem(27);
            display: flex;
            padding: px2rem(63);
            align-items: center;
            .data-item {
                flex: 1;
                display: flex;
                flex-direction: column;
                align-items: center;
                font-weight: 400;
                text-align: center;
                &-value {
                    font-size: px2rem(48);
                    color: #1F1F1F;
                    margin-bottom: px2rem(12);
                }
                &-label {
                    font-size: px2rem(36);
                    color: #858585;
                }
            }
            .split-line {
                flex: 0 0 2px;
                height: px2rem(60);
                background-color: #E0E0E0;
            }
        }
        .basic-info {
            display: flex;
            align-items: center;
            width: px2rem(1140);
            .portrait {
                flex: 0 0 px2rem(188);
                max-height: px2rem(251);
                margin-right: px2rem(36);
                border-radius: px2rem(39);
                overflow: hidden;
                .pc-img-wrapper {
                    width: px2rem(251);
                    height: px2rem(251);
                    img {
                        width: px2rem(251);
                        margin-left: px2rem(-33);
                    }
                }
                .mobile-img-wrapper {
                    width: px2rem(188);
                    height: px2rem(188);
                    img {
                        width: px2rem(188);
                    }
                }

            }
            .name-tag {
                flex: 0 0 px2rem(607);
                .game-name {
                    font-size: px2rem(57);
                    font-weight: bold;

                    img {
                        height: px2rem(51);
                        margin-left: px2rem(18);
                    }
                }
                .game-tag {
                    font-size: px2rem(39);
                    color: #858585;
                    padding-bottom: px2rem(5);
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    width: px2rem(580);
                    span {
                        margin-right: px2rem(30);
                    }
                }
                .rank-info {
                    display: flex;
                    margin-top: px2rem(15);
                    box-sizing: border-box;
                    font-size: px2rem(30);
                    height: px2rem(50);
                    max-width: px2rem(580);
                    overflow-x: scroll;
                    overflow-y: hidden;
                    &::-webkit-scrollbar {
                        display: none;
                    }
                    &>div {
                        height: px2rem(42);
                        display: inline-block;
                        line-height: px2rem(42);
                        text-align: center;
                        border-radius: px2rem(24);
                        flex-shrink: 0;
                    }
                    .classify {
                        padding: 0 px2rem(15);
                        font-size: px2rem(30);
                        margin-right: px2rem(24);
                        border: 1px solid;
                        margin-bottom: px2rem(17);
                    }
                }
            }

            .info-score {
                flex: 0 0 px2rem(240);
                margin-left: px2rem(80);
                display: flex;
                align-items: center;
                flex-direction: column;
                justify-content: space-between;
                height:px2rem(180);
                padding: px2rem(27) 0 0;
                box-sizing: border-box;
                color:#ffffff;
                background: url('~public/assets/imgs/score-bg.png') no-repeat;
                background-size: cover;
                .score-content{
                    font-size:px2rem(57);
                    line-height:px2rem(57);
                }
                .star-content-wrap{
                    position: relative;
                    top:px2rem(-20);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    display: -webkit-flex;
                    -webkit-align-items: center;
                    -webkit-justify-content: center;
                    width:px2rem(160);
                    height:px2rem(40);
                    background-image: linear-gradient(90deg, #143CFF 0%, #0864E8 100%);
                    box-shadow: 0 px2rem(4) px2rem(8) 0 rgba(0,94,195,0.30);
                    border-radius: px2rem(20);
                    // background: url('~public/assets/imgs/score-star-content.png') no-repeat;
                    // background-size: cover;
                    .star-content{
                        display: -webkit-flex;
                        display:flex;
                        transform: scale(.55);
                    }
                }
            }
        }
        .single-end-tour {
            box-sizing: border-box;
            width: px2rem(1140);
            height: px2rem(150);
            background: #F8F8F8;
            border-radius: px2rem(27);
            padding-left: px2rem(60);
            padding-right: px2rem(60);
            display: flex;
            align-items: center;
            justify-content: space-between;
            .left {
                font-size: px2rem(51);
                img {
                    width: px2rem(47);
                    margin-right: px2rem(15);
                    position: relative;
                    top: px2rem(5);
                }
            }
            .right {
                font-size: px2rem(48);
            }
        }
        .end-tour {
            height: px2rem(341);
            background-color: #F8F8F8;
            border-radius: px2rem(27);
            .end-tour-tab {
                width: 100%;
                height: px2rem(112);
                font-size: px2rem(51);
                color: #858585;
                display: flex;
                align-items: center;
                border-bottom: 1px solid #e0e0e0;
                .tab-name {
                    img {
                        width: px2rem(47);
                        margin-right: px2rem(15);
                        position: relative;
                        top: px2rem(5);
                    }
                }
                .tab-item {
                    width: px2rem(280);
                    height: px2rem(112);
                    line-height: px2rem(112);
                    box-sizing: border-box;
                    text-align: center;
                }
                .tab-tiem-focus {
                    color: #1F1F1F;
                    &>div {
                        display: inline-block;
                        border-bottom: px2rem(6) solid #1F1F1F;
                    }

                }
            }
            .end-tour-content {
                display: flex;
                font-size: px2rem(48);
                height: px2rem(220);
                align-items: center;
                .content-item {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    &.width-fixed {
                        flex: 0 0 px2rem(321);
                    }
                    &-key {
                        font-size: px2rem(36);
                        line-height: px2rem(36);
                        color: #858585;
                    }
                    &-value {
                        margin-top: px2rem(24);
                        font-size: px2rem(42);
                        line-height: px2rem(42);
                        color: #1F1F1F;
                    }
                }
                .split-line {
                    flex: 0 0 px2rem(2);
                    height: px2rem(60);
                    background-color: #E0E0E0;
                }
            }
        }
        .pricetrend {
            .pricetrend-top {
                display: flex;
                justify-content:space-between;
                align-items: center;
                .pricetrend-top-right {
                    display: flex;
                    justify-content:space-between;
                    align-items:center;
                    .pricetrend-showMore {
                        width: px2rem(84);
                        height: px2rem(42);
                        font-family: PingFangSC-Regular;
                        font-size: px2rem(42);
                        color: #8D9197;
                        line-height: 42px;
                        font-weight: 400;
                        color: #8D9197 100%;
                        margin-right: px2rem(15);
                    }
                    .pricetrend-icon {
                        width: px2rem(44);
                        height: px2rem(24);
                        padding: px2rem(10) px2rem(10);
                    }
                    .left {
                        height: 42px;
                        font-family: PingFangSC-Medium;
                        font-size: 42px;
                        color: #3388FF;
                        line-height: 42px;
                        font-weight: 500;
                    }
                    .middle {
                        margin: 0 18px;
                        color: #8D9197;
                    }
                    .right {
                        height: 42px;
                        font-family: PingFangSC-Regular;
                        font-size: 42px;
                        color: #8D9197;
                        line-height: 42px;
                        font-weight: 400;
                    }
                }
            }
        }
        .desc {
            .previewImg {
                margin-bottom: px2rem(54);
            }
            .desc-info {
                display: flex;
                align-items: center;
                font-size: px2rem(48);
                margin-top: px2rem(44);
                img {
                    margin-left: px2rem(48);
                }
            }
        }
        .configuration-request {
            height: px2rem(183);
            line-height: px2rem(183);
            border-top: px2rem(1) solid #E0E0E0;
            border-bottom: px2rem(1) solid #E0E0E0;
            margin: 0 px2rem(-51) 0 px2rem(-51);
            padding: 0 px2rem(51);
        }
        .media-list {
            margin-left: px2rem(-51);
            margin-right: px2rem(-51);
            padding-left: px2rem(51);
            display: flex;
            flex-shrink: 0;
            &-item {
                margin-right: px2rem(24);
            }
            &-item-h {
                height: px2rem(313);
                &>img {
                    width: px2rem(557);
                    height: px2rem(313);
                    border-radius: px2rem(27);
                }
                .gp-app-video {
                    width: px2rem(557);
                    height: px2rem(313);
                }
            }
            &-item-v {
                height: px2rem(557);
                &>img {
                    width: px2rem(313);
                    height: px2rem(557);
                    border-radius: px2rem(27);
                }
                .gp-app-video {
                    width: px2rem(313);
                    height: px2rem(557);
                }
            }
            .video-h {
                width: px2rem(757);
                height: px2rem(557);
            }
        }
        .safe-check {
            .check {
                height: px2rem(42);
                display: flex;
                .check-icon {
                    width: px2rem(35);
                }
                .safe {
                    font-size: px2rem(42);
                    color: #37CA88;
                    letter-spacing: 0;
                    line-height: px2rem(42);
                    font-weight: 400;
                    display: inline-block;
                    margin-left: px2rem(15);
                }
                .arrow-up {
                    width: px2rem(35);
                    height: px2rem(20);
                    margin-left: px2rem(15);
                    margin-top: px2rem(11);
                }
            }
        }
    }
    .no-pak-tips {
        font-size: 30px;
        color: #B8B8B8;
    }

    .trans-title {
        color: #FFF !important;
    }

    .vert-center {
        display: flex;
        align-items: center;
    }

    .trans-desc {
        color: rgba(255,255,255,0.80) !important;
    }

    .trans-official-tag {
        display: inline-block;
        margin-left: px2rem(15);
        height: px2rem(48);
        width: px2rem(204);
    }

    .trans-bg {
        background-color: rgba(255, 255, 255, .2) !important;
    }

    .trans-border {
        border-color: rgba(255, 255, 255, .3) !important;
        .tab-tiem-focus {
            color: #FFF;
            &>div {
                border-bottom: px2rem(6) solid #FFF !important;
            }
        }
    }
    .offical-gap-top{
        margin: px2rem(100) px2rem(-10) 0;
    }
</style>